export const getFileNameWithoutExtension = (filename: string) => {
  return (
    (!filename ? '' : filename.substring(0, filename.lastIndexOf('.'))) ||
    filename
  )
}
